module.exports = __webpack_public_path__ + "static/media/users-groups-icon.59c3b54e.svg";